/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SpecialitySymptomPreferences from './speciality-symptom-preferences';
import SpecialitySymptomPreferencesDetail from './speciality-symptom-preferences-detail';
import SpecialitySymptomPreferencesUpdate from './speciality-symptom-preferences-update';
import SpecialitySymptomPreferencesDeleteDialog from './speciality-symptom-preferences-delete-dialog';

const SpecialitySymptomPreferencesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SpecialitySymptomPreferences />} />
    <Route path="new" element={<SpecialitySymptomPreferencesUpdate />} />
    <Route path=":id">
      <Route index element={<SpecialitySymptomPreferencesDetail />} />
      <Route path="edit" element={<SpecialitySymptomPreferencesUpdate />} />
      <Route path="delete" element={<SpecialitySymptomPreferencesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SpecialitySymptomPreferencesRoutes;
